// extracted by mini-css-extract-plugin
export default {"button":"right-sidebar-open-button_button__o9vUM"};